<template>
  <b-modal
    id="modal-email-order"
    ref="emailOrderModal"
    :title="modalTitle"
    :ok-title="'send' | i18n"
    :cancel-title="'abort' | i18n"
    ok-variant="primary"
    cancel-variant="outline-primary"
    button-size="sm"
    :ok-disabled="!isFormValid"
    @ok="onSubmit"
    @show="resetModal"
    @hidden="resetModal"
  >
    <b-form-group
      id="email"
      :label="'email' | i18n"
      label-for="email-input"
    >
      <b-form-input
        id="email-input"
        v-model="formData.email"
        trim
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'EmailOrderModal',
  props: {
    orderNumber: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      formData: {
        email: null
      }
    };
  },
  computed: {
    isFormValid: function () {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return this.formData.email && re.test(this.formData.email.toLowerCase());
    },
    modalTitle: function () {
      return this.$translate('order_send_to_email_modal_title', {orderNumber: this.orderNumber});
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.$emit('submit', {email: this.formData.email});
    },
    resetModal() {
      this.formData.email = null;
    }
  }
};
</script>

<style scoped>

</style>
